import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import {
  CreateRFQFromProjectCommandRequest,
  CreateRFQFromProjectCommandResponse,
  GetRequestForQuotationsQueryResponse,
  GetRequestForQuotationsResponse,
  RequestForQuotationDto,
  SendRequestForQuotationRequest,
  SendRequestForQuotationResponse,
  UpdateRfqBoMItemsRequest,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import {
  HttpGetMetaData,
  InternalAPI,
} from 'services/APIs/InternalAPI/InternalAPI'

export interface IProjectRFQAPI {
  getRFQs(
    meta?: HttpGetMetaData<RequestForQuotationDto>,
  ): Promise<GetRequestForQuotationsQueryResponse>
  getRFQById(id: string): Promise<GetRequestForQuotationsResponse>
  createRequestForQuotation(
    req: CreateRFQFromProjectCommandRequest,
  ): Promise<CreateRFQFromProjectCommandResponse>
  updateRfqBomItems(rfqId: string, req: UpdateRfqBoMItemsRequest): Promise<void>
  sendRequestForQuotation(
    req: SendRequestForQuotationRequest,
  ): Promise<SendRequestForQuotationResponse>
}

export class ProjectRFQAPI extends InternalAPI implements IProjectRFQAPI {
  private readonly partyId: string

  constructor(
    partyId: string,
    projectId: string,
    onRequestChanged?: OnRequestChangeCallback,
  ) {
    super(
      `/api/parties/${partyId}/project/${projectId}/requestForQuotations`,
      onRequestChanged,
    )
    this.partyId = partyId
  }

  public async getRFQs(
    meta?: HttpGetMetaData<RequestForQuotationDto>,
  ): Promise<GetRequestForQuotationsQueryResponse> {
    return this.GetAsync<GetRequestForQuotationsQueryResponse>({
      relativePath: '/',
      id: 'getRFQs',
      params: {
        ...(meta || {}),
      },
    })
  }

  public async getRFQById(
    id: string,
  ): Promise<GetRequestForQuotationsResponse> {
    return this.GetAsync<GetRequestForQuotationsResponse>({
      relativePath: `/${id}`,
      id: 'getRFQById',
    })
  }

  public async createRequestForQuotation(
    req: CreateRFQFromProjectCommandRequest,
  ): Promise<CreateRFQFromProjectCommandResponse> {
    return this.PostAsync<CreateRFQFromProjectCommandResponse>({
      relativePath: '/create',
      id: 'createRequestForQuotation',
      data: req,
    })
  }

  public async updateRfqBomItems(
    rfqId: string,
    req: UpdateRfqBoMItemsRequest,
  ): Promise<void> {
    return this.PutAsync<void>({
      relativePath: `/${rfqId}/bom-items`,
      uri: `${this.baseAddress}/api/parties/${this.partyId}/rfq/${rfqId}/bom-items`,
      id: `updateRfqBomItems-${rfqId}`,
      data: req,
    })
  }

  public async sendRequestForQuotation(
    req: SendRequestForQuotationRequest,
  ): Promise<SendRequestForQuotationResponse> {
    return this.PostAsync<SendRequestForQuotationResponse>({
      relativePath: `/${req.requestForQuotationId}/send`,
      id: `sendRequestForQuotation-${req.requestForQuotationId}`,
      data: req,
    })
  }
}
